import CategoriesDashboard from './CategoriesDashboard';

export default CategoriesDashboard;
